import { MUTATION_KEY, QUERY_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useScheduleDowntime = (handleModalClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.SCHEDULE_DOWNTIME],
    (data) => ApiService.scheduleDowntime(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_SCHEDULE_DOWNTIME_LIST);
        handleModalClose()
        toast.success("Down time saved successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useScheduleDowntime;
